import { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import Loading from "../../Common/Loading";
import SidePanel from "../../Components/SidePanel/SidePanel";
import { useNavigate, useParams } from "react-router-dom";

const ViewQRBasis = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();

    const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
    const [loading, setLoading] = useState(false);
    const [logoImageShow, setLogoImageShow] = useState("");
    const [rightPanelThemeColor, setRightPanelThemeColor] = useState("");

    const [questionsViewList, setQuestionsViewList] = useState([]);
    const [qRBasisName, setQRBasisName] = useState("");
    const [showQuestionsViewList, setShowQuestionsViewList] = useState([]);

    useEffect(() => {
        const userRole = JSON.parse(localStorage.getItem("userRole"));
        const token = localStorage.getItem("authToken");
        if (token && userRole.includes("Administrateur")) {
            const logo_image = JSON.parse(localStorage.getItem("logo_image"));
            const right_panel_color = JSON.parse(
                localStorage.getItem("right_panel_color")
            );
            setRightPanelThemeColor(right_panel_color);
            setLogoImageShow(logo_image);
            QRBasisQuestionsList();
        } else {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        if (flashMessage.message) {
            const timer = setTimeout(() => {
                setFlashMessage({ type: "", message: "" });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [flashMessage]);

    useEffect(() => {
        if (id && questionsViewList?.length != 0) {
            ShowQRBasisDetails(id);
        }
    }, [id, questionsViewList]);

    const QRBasisQuestionsList = async () => {
        try {
            const response = await FilePageService.qr_basis_questions_list();
            if (response.data.status) {
                setQuestionsViewList(response.data.questionsList);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const ShowQRBasisDetails = async (id) => {
        try {
            const response = await FilePageService.qr_basis_show(id);
            if (response.data.status) {
                const details = response.data.qrBasis;

                const viewQuestions = questionsViewList?.filter((q) => details.question_ids.includes(q.id));
                setShowQuestionsViewList(viewQuestions);
                setQRBasisName(details.name || "");
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    return (
        <Fragment>
            <style>
                {` button.btn.btn-primary  { background-color: ${localStorage.getItem("button_color")
                    ? JSON.parse(localStorage.getItem("button_color"))
                    : "#e84455"
                    } !Important};`}
            </style>

            <SidePanel
                sidebarLogo={
                    (logoImageShow !== "" ||
                        logoImageShow !== null ||
                        logoImageShow !== undefined) &&
                    `${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`
                }
            />

            <div
                className="dashboard-main-content user-dashboard"
                style={{ backgroundColor: rightPanelThemeColor }}
            >
                <div className="top-header">
                    <div className="mt-3 d-md-flex justify-content-between align-items-center">
                        <h1 className="m-md-0 mb-3">Liste de questions sur la {qRBasisName}</h1>
                    </div>
                </div>
                <div className="table-wrapper mt-24">
                    {loading ? <Loading />
                        : (
                            <>
                                {/* Back Button */}
                                <div className="d-block mb-2">
                                    <span className="back-screen" onClick={() => navigate("/qr-basis")}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="23"
                                            viewBox="0 0 18 23"
                                            fill="none"
                                        >
                                            <path
                                                d="M17.4148 11.8702C17.0398 11.4952 16.5311 11.2846 16.0008 11.2846C15.4705 11.2846 14.9619 11.4952 14.5868 11.8702L11.0008 15.4562V2.28418C11.0008 1.75375 10.7901 1.24504 10.415 0.869966C10.04 0.494893 9.53125 0.28418 9.00081 0.28418C8.47038 0.28418 7.96167 0.494893 7.5866 0.869966C7.21153 1.24504 7.00081 1.75375 7.00081 2.28418V15.4562L3.41481 11.8702C3.03761 11.5059 2.53241 11.3043 2.00801 11.3088C1.48362 11.3134 0.981993 11.5237 0.611177 11.8945C0.240361 12.2654 0.0300231 12.767 0.0254662 13.2914C0.0209094 13.8158 0.222498 14.321 0.586814 14.6982L7.58681 21.6982C7.96187 22.0731 8.47049 22.2838 9.00081 22.2838C9.53114 22.2838 10.0398 22.0731 10.4148 21.6982L17.4148 14.6982C17.7898 14.3231 18.0004 13.8145 18.0004 13.2842C18.0004 12.7539 17.7898 12.2452 17.4148 11.8702Z"
                                                fill="#00366B"
                                            />
                                        </svg>
                                    </span>
                                </div>

                                {/* Table */}
                                <div className="table-wrapper mt-16 p-0">
                                    <div className="table-wrap mt-24">
                                        <Table responsive hover>
                                            <thead>
                                                <tr>
                                                    <th>Question</th>
                                                    <th>Input Type</th>
                                                    <th>Is Required</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {showQuestionsViewList?.length ? (
                                                    showQuestionsViewList.map((data) => (
                                                        <tr key={data.id}>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="text-elips">{data.question_text}</span>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {data?.input_type
                                                                    ? data.input_type.charAt(0).toUpperCase() + data.input_type.slice(1)
                                                                    : ""}
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className={`${data.is_required ? "verified" : "incomplete"} badges`}
                                                                >
                                                                    {data.is_required ? "Oui" : "Non"}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td colSpan="4">{t("NorecordsfoundLabel")}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
        </Fragment>
    );
};

export default ViewQRBasis;